/** @format */
import { NamedException } from '@toucan/client/global/application';

export async function withNamedTryCatch<T = unknown>(
    method: () => T,
    id: string
): Promise<T> {
    try {
        return await method();
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error -- Legacy code: do not use as an example.
        throw new NamedException(id, error);
    }
}
